'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default =

function ($window) {
  "ngInject";
  return {
    restrict: 'C',
    link: function link(scope, element, attributes) {

      angular.element(document).on('scroll', function () {
        element.toggleClass('show', $window.scrollY > 100);
      });
      element.on('click', function () {
        var verticalOffset = typeof verticalOffset != 'undefined' ? verticalOffset : 0,
            body = $('body'),
            offset = body.offset();

        $('html, body').animate({ scrollTop: offset.top }, 500, 'linear');
      });
    }
  };
};


// WEBPACK FOOTER //
// ./app/base/directives/toTop.js